import { AbstractControl, FormControl, FormGroup, ValidatorFn } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { shipmentIdentifier } from '@shared';

export function timeValidator(control: FormControl) {
  return !control.value
    ? control
    : /^(0?[1-9]|1[0-2]):([0-5]\d)\s?((?:A|P)\.?M\.?)$/i.test(control.value)
    ? true
    : false;
}

export function emailValidator(control: FormControl) {
  return !control.value ? control : /\S+@\S+\.\S+/.test(control.value) ? true : false;
}

export function numericValidator(control: FormControl) {
  return !control.value ? control : /^\d+$/.test(control.value) ? true : false;
}

export function phoneValidator(control: FormControl) {
  return !control.value
    ? control
    : /(297|93|244|1264|358|355|376|971|54|374|1684|1268|61|43|994|257|32|229|226|880|359|973|1242|387|590|375|501|1441|591|55|1246|673|975|267|236|1|61|41|56|86|225|237|243|242|682|57|269|238|506|53|5999|61|1345|357|420|49|253|1767|45|1809|1829|1849|213|593|20|291|212|34|372|251|358|679|500|33|298|691|241|44|995|44|233|350|224|590|220|245|240|30|1473|299|502|594|1671|592|852|504|385|509|36|62|44|91|246|353|98|964|354|972|39|1876|44|962|81|76|77|254|996|855|686|1869|82|383|965|856|961|231|218|1758|423|94|266|370|352|371|853|590|212|377|373|261|960|52|692|389|223|356|95|382|976|1670|258|222|1664|596|230|265|60|262|264|687|227|672|234|505|683|31|47|977|674|64|968|92|507|64|51|63|680|675|48|1787|1939|850|351|595|970|689|974|262|40|7|250|966|249|221|65|500|4779|677|232|503|378|252|508|381|211|239|597|421|386|46|268|1721|248|963|1649|235|228|66|992|690|993|670|676|1868|216|90|688|886|255|256|380|598|1|998|3906698|379|1784|58|1284|1340|84|678|681|685|967|27|260|263)(9[976]\d|8[987530]\d|6[987]\d|5[90]\d|42\d|3[875]\d|2[98654321]\d|9[8543210]|8[6421]|6[6543210]|5[87654321]|4[987654310]|3[9643210]|2[70]|7|1)\d{4,40}$/.test(
        control.value
      )
    ? true
    : false;
}

export function maxValidationMessage(err: any, field: FormlyFieldConfig, message: string) {
  return `${field.templateOptions?.maxLength}`;
}

export function validateValue(form: FormGroup): ValidatorFn {
  return (
    ctrl: AbstractControl
  ): null | {
    confirmationInvalid?: boolean;
    infoNoticeInvalid?: boolean;
    pickupRecordShipmentInvalid?: boolean;
    proNumberInvalid?: boolean;
    trackingNumberInvalid?: boolean;
    maxLengthError?: boolean;
  } => {
    const value = ctrl.value as string;
    const key = form.get('shipmentIdentifier')?.value as string | 'Bill of Lading';

    switch (key) {
      case shipmentIdentifier.confirmationNumber:
        if (!/^([a-zA-Z]{3}\d{8}){1,8}$/.test(value)) {
          return { confirmationInvalid: true };
        }
        break;
      case shipmentIdentifier.infoNoticeNumber:
        if (!/^(9)[[a-zA-Z0-9]{11}$/.test(value)) {
          return { infoNoticeInvalid: true };
        }
        break;
      case shipmentIdentifier.shipmentId:
      case shipmentIdentifier.pickupRecordNumber:
        if (!/^[a-zA-Z0-9]{11}$/.test(value)) {
          return { pickupRecordShipmentInvalid: true };
        }
        break;
      case shipmentIdentifier.proNumber:
        if (value.length !== 9) {
          return { proNumberInvalid: true };
        }
        break;
      case shipmentIdentifier.trackingNumber:
        if (!/(^(([a-zA-Z0-9][0-9]{10})|(1[zZ][a-zA-Z0-9]{6}[a-zA-Z0-9]{2}[0-9]{4}[0-9]{4})|(1[zZ]\\s[a-zA-Z0-9]{6}\\s[a-zA-Z0-9]{2}\\s[0-9]{4}\\s[0-9]{4}))$)/.test(value)) {
          return { trackingNumberInvalid: true };
        }
        break;
      case shipmentIdentifier.purchaseOrderNumber:
      case shipmentIdentifier.referenceNumber:
      case shipmentIdentifier.invoiceNumber:
      case shipmentIdentifier.billOfLading:
      case shipmentIdentifier.claimNumber:
      case shipmentIdentifier.packageReferenceNumber:
      case shipmentIdentifier.claimNumber:
      case shipmentIdentifier.mailInnovations:
        if (!/^.{0,40}$/.test(value)) {
          return { maxLengthError: true };
        }
    }
    return null;
  };
}

export function registerTranslateExtension(translate: TranslateService) {
  return {
    validationMessages: [
      {
        name: 'required',
        message() {
          return translate.stream('createCase.requiredError');
        },
      },
      {
        name: 'email',
        message() {
          return translate.stream('createCase.emailError');
        },
      },
      {
        name: 'numeric',
        message() {
          return translate.stream('createCase.numbersError');
        },
      },
      {
        name: 'maxlength',
        message: (error: any, field: FormlyFieldConfig) => {
          return `${translate.instant('createCase.maxlengthError')} ${field.templateOptions?.maxLength}`;
        },
      },
      {
        name: 'phone',
        message() {
          return translate.stream('createCase.phoneError');
        },
      },
      {
        name: 'validatePhoneNumber',
        message() {
          return translate.stream('createCase.phoneError');
        },
      },
      {
        name: 'time',
        message() {
          return translate.stream('createCase.timeError');
        },
      },
    ],
  };
}
